import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { CITY_SUBPAGES, CLUSTER_HEADER_CATEGORY } from 'utils/constant';

import SearchBar from '../common/SearchBar';
import SubHeader from '../common/SubHeader';

import CityClusterHeaderTitle from './CityClusterHeaderTitle';

const CityClusterHeader = (data) => {
  const { subPageName } = data;
  const [pageTitle, setPageTitle] = useState('');

  return (
    <Fragment>
      <div className="job-title-search container d-flex flex-column-reverse flex-lg-row align-items-start">
        <CityClusterHeaderTitle
          showJobsCount={subPageName === CITY_SUBPAGES.JOB}
          {...data}
          getPageTitle={setPageTitle}
        />
        <SearchBar
          className={classNames('z-mt-12 z-mb-20 z-mb-lg-0 z-ml-lg-20', {
            'z-mt-lg-44': pageTitle.length > 40,
            'z-mt-lg-40': pageTitle.length <= 40,
          })}
          subPageName={subPageName}
          clusterCategory={CLUSTER_HEADER_CATEGORY.CITY}
        />
      </div>
      <div className="sub-header-container">
        <SubHeader {...data} maxSubheaderItemsCount={8}/>
      </div>
    </Fragment>
  );
};

const mapDispatchToProps = {};

export default connect(
  ({ user }) => ({
    user,
  }),
  mapDispatchToProps
)(CityClusterHeader);
